import useQueryParams from 'hooks/useQueryParams'
import { useCallback, useMemo } from 'react'
import { replace } from 'connected-react-router'
import { useAppDispatch } from 'hooks/reduxHooks'

const EXPERIENCES_SORT_BY_TYPE = 'sortBy'
const LATEST = 'Latest'
const ENDING_SOON = 'Ending Soon'
const EXPERIENCES_PRICE_LOWEST = 'Price (Lowest)'
const EXPERIENCES_PRICE_HIGHEST = 'Price (Highest)'
const EXPERIENCES_PRICE_RECOMMENDED = 'Recommended'

const SORT_OPTIONS = {
  type: { label: EXPERIENCES_PRICE_RECOMMENDED },
  latest: { label: LATEST },
  endingsoon: { label: ENDING_SOON },
  'price.asc': { label: EXPERIENCES_PRICE_LOWEST },
  'price.desc': { label: EXPERIENCES_PRICE_HIGHEST },
}

export default function useExperiencesSortOptions(defaultSortBy: Experiences.SortTypes = 'type') {
  const appDispatch = useAppDispatch()
  const queryParameters = useQueryParams()

  const sortBy = useMemo<Experiences.SortTypes>(() => {
    return extractSortFromUrl(queryParameters, defaultSortBy)
  }, [defaultSortBy, queryParameters])

  const setSortBy = useCallback((newSortBy: Experiences.SortTypes) => {
    const newUrlFilters = convertSortToUrl(newSortBy, queryParameters)
    appDispatch(replace({
      search: newUrlFilters.toString(),
    }))
  }, [appDispatch, queryParameters])

  const sortOptions = SORT_OPTIONS

  return {
    sortBy,
    setSortBy,
    sortOptions,
  }
}

function extractSortFromUrl(urlSortBy: URLSearchParams, defaultSortBy: Experiences.SortTypes): any {
  const sortOptions: Experiences.SortTypes = defaultSortBy
  if (urlSortBy.has(EXPERIENCES_SORT_BY_TYPE)) {
    return urlSortBy.get(EXPERIENCES_SORT_BY_TYPE)
  }
  return sortOptions
}

function convertSortToUrl(newSortBy: Experiences.SortTypes, currentSearchParams: URLSearchParams) {
  const searchParams = new URLSearchParams(currentSearchParams)
  if (newSortBy) {
    searchParams.set(EXPERIENCES_SORT_BY_TYPE, String(newSortBy))
  }
  return searchParams
}
